import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { createContext, useState } from "react";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";
import WhyWeNeedAIImageDetector from "./WhyWeNeedAIImageDetector";
import AIImageDetector from "./AIImageDetector";

//create context
export const aiImageDetectorContext = createContext({
  formFile: "",
  image_data: "",
  probability: 0, //ai probability
  isLoaded: false,
});

function AIImageDetectorMain() {
  //detect texts form values
  const [aiImageDetectorValues, setAIImageDetectorValues] = useState({
    formFile: "",
    image_data: "",
    probability: 0,
    isLoaded: false,
  });

  return (
    <div>
      {/*Firebase analytics */}
      {logEvent(analytics, "AI Image Detector Screen")}

      {/*Add title and metadata */}
      <title>
        Detect AI Generated Images / Photos for free (100% Accuracy)
      </title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href="https://humanizetexts.com/ai-image-detector"
      />
      <meta
        name="description"
        content="Detect wheather a image is computer-generated or human captured. Also, find out what percentage of the image is AI-generated."
      ></meta>
      <meta
        name="keywords"
        content="ai image detector,fake image detector,chatgpt image detector,gemini image detector,morphed image detector,artificial intelligence detector,aı detector,ai detector free,chatgpt detector,ai detect,ai detecting,chatgpt detectors,detect ai,ai detection tool,gemini detector,bot detector,perplexity detector,copilot detector,"
      ></meta>
      <meta
        property="og:title"
        content="AI Generated Image/Photo Detector for free (100% Accuracy)"
      />
      <meta
        name="twitter:title"
        content="AI Generated Image/Photo Detector for free (100% Accuracy)"
      ></meta>

      {/* Main Content */}
      <aiImageDetectorContext.Provider
        value={{
          aiImageDetectorValues,
          setAIImageDetectorValues,
        }}
      >
        <div className="p-3">
          {/* NavBar component */}
          <NavBar />
          {/* AI Image Detector */}
          <AIImageDetector />
          {/* Why we need AI image detector? */}
          <WhyWeNeedAIImageDetector />
          {/* Footer */}
          <Footer />
        </div>
      </aiImageDetectorContext.Provider>
    </div>
  );
}

export default AIImageDetectorMain;
